import type { CenterProps } from '@mantine/core';
import { Center, createStyles } from '@mantine/core';
import { EntityType } from '@repo/common/enums/entityType';
import { memo } from 'react';
import IntegrationLogo from '../../../components/IntegrationLogo';

const useStyles = createStyles((theme) => ({
	icon: {
		borderRadius: theme.radius.sm,
		padding: theme.spacing['2xs'],
		backgroundColor: theme.other.getColor('surface/secondary/default'),
	},
}));

export const SlackIcon = memo(
	(props: Omit<CenterProps, 'className' | 'children'>) => {
		const { classes } = useStyles();

		return (
			<Center className={classes.icon} {...props}>
				<IntegrationLogo
					size={16}
					entityType={EntityType.integration}
					integrationType="slack"
				/>
			</Center>
		);
	}
);
